import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Testimonials() {
  return <section className="w-full bg-sky px-4 py-14 md:py-20" data-id="element-257" data-mp="3fxun461bgqtd">
      <div className="mx-auto max-w-6xl" data-id="element-258" data-mp="3b1cir79weuhk">
        <SectionHeading kicker="What other dental professionals are saying" title="A resource designed for clinical clarity" intro="The most useful educational resources help professionals organize what they know and identify what they still need to investigate." data-id="element-259" data-mp="3b0az4eetgzo8" />

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-260" data-mp="2x2w3ut1vtxoc">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm" data-id="element-261" data-mp="2s42wzjh3p4x5">
              <div className="flex items-center justify-between" data-id="element-262" data-mp="v72ixpixvamv">
                <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-263" data-mp="qbn3it5a96oc">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-264" data-mp="m51dby0rthb2" data-mpi={i} />)}
                </div>
                <QuoteIcon className="h-7 w-7 text-teal/40" aria-hidden="true" data-id="element-265" data-mp="78tvh4cu4ryy" />
              </div>
              <blockquote className="mt-4 flex-1 text-base leading-relaxed text-ink" data-id="element-266" data-mp="c7wp7snd7brm">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-line pt-5" data-id="element-267" data-mp="zxr0w6vy6uaa">
                <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-teal" loading="lazy" data-id="element-268" data-mp="14uhemnka5dsj" />
                <div data-id="element-269" data-mp="v3wjxb7q8tew">
                  <p className="font-bold text-navy" data-id="element-270" data-mp="v3d2dvlzo71e">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-271" data-mp="1itqvlpgb8bxk">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <CTAButton className="mt-10" label="I want the full collection" subtext="Instant access · $27 USD" data-id="element-272" data-mp="1xi0lr5tr9nwj" />
      </div>
    </section>;
}